import { render } from "./ExchangeHistory.vue?vue&type=template&id=b036d6a4&scoped=true&ts=true"
import script from "./ExchangeHistory.vue?vue&type=script&lang=ts"
export * from "./ExchangeHistory.vue?vue&type=script&lang=ts"

import "./ExchangeHistory.vue?vue&type=style&index=0&id=b036d6a4&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b036d6a4"]])

export default __exports__